// extracted by mini-css-extract-plugin
module.exports = {"DataBox":"DataBox_DataBox__2pj2D","Type":"DataBox_Type__36SUy","Value":"DataBox_Value__1G_9B"};